import React from 'react'

const About = ()=>{

  return (
    <div style={{marginTop:"150px"}}>
        <h2>
            {" "}
            This is a React CRUD Web Application Build using Node and Express along with routing
        </h2>

    </div>
  )
}

export default About
